import {
  loginIcon,
  eyeIcon,
  saveAs,
  usersIcon,
} from "@excalidraw/excalidraw/components/icons";
import { MainMenu } from "@excalidraw/excalidraw/index";
import React from "react";

import { isDevEnv } from "@excalidraw/common";

import type { Theme } from "@excalidraw/element/types";

import { LanguageList } from "../app-language/LanguageList";
import { useCloudState } from "../cloud/api";
import { cloudSync } from "../cloud/CloudSync";

import { saveDebugState } from "./DebugCanvas";

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
  theme: Theme | "system";
  refresh: () => void;
  onOpenCloud: () => void;
}> = React.memo((props) => {
  const { user, activeProject } = useCloudState();

  return (
    <MainMenu>
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      <MainMenu.DefaultItems.CommandPalette className="highlighted" />
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.DefaultItems.Help />
      <MainMenu.DefaultItems.ClearCanvas />
      <MainMenu.Separator />
      {user ? (
        <>
          <MainMenu.Item icon={usersIcon} onSelect={() => props.onOpenCloud()}>
            Meus projetos{activeProject ? ` — ${activeProject.name}` : ""}
          </MainMenu.Item>
          <MainMenu.Item
            icon={saveAs}
            onSelect={() => {
              const name =
                window
                  .prompt("Nome da cópia a salvar na nuvem:", "Cópia")
                  ?.trim() || "";
              if (name) {
                void cloudSync.saveAsNew(name);
              }
            }}
          >
            Salvar cena atual como cópia
          </MainMenu.Item>
        </>
      ) : (
        <MainMenu.Item
          icon={loginIcon}
          className="highlighted"
          onSelect={() => props.onOpenCloud()}
        >
          Entrar / Criar conta
        </MainMenu.Item>
      )}
      {isDevEnv() && (
        <MainMenu.Item
          icon={eyeIcon}
          onSelect={() => {
            if (window.visualDebug) {
              delete window.visualDebug;
              saveDebugState({ enabled: false });
            } else {
              window.visualDebug = { data: [] };
              saveDebugState({ enabled: true });
            }
            props?.refresh();
          }}
        >
          Visual Debug
        </MainMenu.Item>
      )}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.Preferences />
      <MainMenu.DefaultItems.ToggleTheme allowSystemTheme theme={props.theme} />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
    </MainMenu>
  );
});
